// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-12b5e22c] .story-actions-wrapper.row {
  padding-inline: var(--12b5e22c-\\\$getStyles\\.previewActionsPaddingInline);
}
[data-v-12b5e22c] .editor-wrapper.row {
  margin-bottom: 16px;
}
[data-v-12b5e22c] .story-editor-component-wrapper.row {
  position: relative;
  bottom: 5px;
  padding-top: 5px;
}
.story-actions-left-container[data-v-12b5e22c] {
  position: relative;
  left: var(--12b5e22c-topStoryActionsLeftOffset);
}
.overlay-border[data-v-12b5e22c] {
  z-index: var(--12b5e22c-overlayZIndex);
  position: fixed;
  background-color: transparent;
  outline: 2px solid white;
  border-radius: 5px;
}
.overlay-piece[data-v-12b5e22c] {
  position: fixed;
  background: var(--12b5e22c-\\\$getStyles\\.previewBackgroundColor);
  z-index: var(--12b5e22c-overlayZIndex);
  opacity: 0;
  animation: fadeIn-12b5e22c 0.5s ease-in forwards;
}
@keyframes fadeIn-12b5e22c {
to {
    opacity: 1;
}
}
.overlay-piece.fade-out[data-v-12b5e22c] {
  opacity: 0;
}
.preview-actions[data-v-12b5e22c] {
  padding-bottom: var(--12b5e22c-\\\$getStyles\\.previewActionsPaddingBottom);
}
.editor-content-wrapper[data-v-12b5e22c] {
  margin: 0 auto;
}
.overlay-piece[data-v-12b5e22c] svg {
  position: relative;
  top: 2px;
  fill: white;
}
.overlay-piece[data-v-12b5e22c] .i-button--variant-secondary svg {
  fill: black;
}
.story-flag-wrapper[data-v-12b5e22c] {
  position: relative;
  right: 4px;
  gap: 16px;
}
.close-button[data-v-12b5e22c] {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 4;
}
.fullscreen-button[data-v-12b5e22c] {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 4;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/publication/StoryEditorComponent.vue","webpack://./StoryEditorComponent.vue"],"names":[],"mappings":"AAEA;EACE,wEAAA;ACDF;ADIA;EACE,mBAAA;ACDF;ADIA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ACDF;ADIA;EACE,kBAAA;EACA,+CAAA;ACDF;ADIA;EACE,sCAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,kBAAA;ACDF;ADIA;EACE,eAAA;EACA,+DAAA;EACA,sCAAA;EAEA,UAAA;EACA,gDAAA;ACFF;ADKA;AACE;IACE,UAAA;ACFF;AACF;ADKA;EACE,UAAA;ACHF;ADMA;EACE,wEAAA;ACHF;ADMA;EACE,cAAA;ACHF;ADOE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;ACJJ;ADQI;EACE,WAAA;ACNN;ADWA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;ACRF;ADWA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;ACRF;ADWA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ACRF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.story-actions-wrapper.row) {\n  padding-inline: v-bind(\"$getStyles.previewActionsPaddingInline\");\n}\n\n:deep(.editor-wrapper.row) {\n  margin-bottom: 16px;\n}\n\n:deep(.story-editor-component-wrapper.row) {\n  position: relative;\n  bottom: 5px;\n  padding-top: 5px;\n}\n\n.story-actions-left-container {\n  position: relative;\n  left: v-bind(topStoryActionsLeftOffset);\n}\n\n.overlay-border {\n  z-index: v-bind(overlayZIndex);\n  position: fixed;\n  background-color: transparent;\n  outline: 2px solid white;\n  border-radius: 5px;\n}\n\n.overlay-piece {\n  position: fixed;\n  background: v-bind(\"$getStyles.previewBackgroundColor\");\n  z-index: v-bind(overlayZIndex);\n\n  opacity: 0;\n  animation: fadeIn 0.5s ease-in forwards;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n.overlay-piece.fade-out {\n  opacity: 0;\n}\n\n.preview-actions {\n  padding-bottom: v-bind(\"$getStyles.previewActionsPaddingBottom\");\n}\n\n.editor-content-wrapper {\n  margin: 0 auto;\n}\n\n.overlay-piece {\n  :deep(svg) {\n    position: relative;\n    top: 2px;\n    fill: white;\n  }\n\n  :deep(.i-button--variant-secondary) {\n    svg {\n      fill: black;\n    }\n  }\n}\n\n.story-flag-wrapper {\n  position: relative;\n  right: 4px;\n  gap: 16px;\n}\n\n.close-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 4;\n}\n\n.fullscreen-button {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  z-index: 4;\n}\n\n",":deep(.story-actions-wrapper.row) {\n  padding-inline: v-bind(\"$getStyles.previewActionsPaddingInline\");\n}\n\n:deep(.editor-wrapper.row) {\n  margin-bottom: 16px;\n}\n\n:deep(.story-editor-component-wrapper.row) {\n  position: relative;\n  bottom: 5px;\n  padding-top: 5px;\n}\n\n.story-actions-left-container {\n  position: relative;\n  left: v-bind(topStoryActionsLeftOffset);\n}\n\n.overlay-border {\n  z-index: v-bind(overlayZIndex);\n  position: fixed;\n  background-color: transparent;\n  outline: 2px solid white;\n  border-radius: 5px;\n}\n\n.overlay-piece {\n  position: fixed;\n  background: v-bind(\"$getStyles.previewBackgroundColor\");\n  z-index: v-bind(overlayZIndex);\n  opacity: 0;\n  animation: fadeIn 0.5s ease-in forwards;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n.overlay-piece.fade-out {\n  opacity: 0;\n}\n\n.preview-actions {\n  padding-bottom: v-bind(\"$getStyles.previewActionsPaddingBottom\");\n}\n\n.editor-content-wrapper {\n  margin: 0 auto;\n}\n\n.overlay-piece :deep(svg) {\n  position: relative;\n  top: 2px;\n  fill: white;\n}\n.overlay-piece :deep(.i-button--variant-secondary) svg {\n  fill: black;\n}\n\n.story-flag-wrapper {\n  position: relative;\n  right: 4px;\n  gap: 16px;\n}\n\n.close-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 4;\n}\n\n.fullscreen-button {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  z-index: 4;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
